module.exports = __webpack_public_path__ + "media/components/assets/img/pks-oslo-driver-cbe4c0713fb7e2cc0d7aacbb1473d29c.png";